import { VStack } from "@chakra-ui/react";
import { useAppSelector } from "lib/redux";
import { isEmpty, keys } from "lodash";
import { pickBy } from "lodash";
import { useMemo } from "react";
import { selectBio } from "./creatorCardSlice";
import { Field } from "./types";
import { CreatorCardContactLink } from './creatorCardContactLink';

const contactKeys: Partial<keyof typeof Field>[] = [Field.email, Field.phone];

export const CreatorCardContact = () => {
  const bio = useAppSelector(selectBio);

  const contactInfo = useMemo(() => (
    pickBy(bio, (value, key: keyof typeof Field) => value && contactKeys.includes(key))
  ), [bio, contactKeys]);

  if (isEmpty(contactKeys)) {
    return null;
  }

  return (
    <VStack>
      {keys(contactInfo).map((key) => <CreatorCardContactLink key={key} contactKey={key} />)}
    </VStack>
  )
};